import "../../assets/css/acknowledge-message.css";
import { Say } from "../../languages";

export function AcknowledgeRecurringDonationMessage() {
  return (
    <div className="acknowledge-message__wrapper">
      <p>
        <Say phrase="chosen.submission.acknowledgement" />
      </p>
      {
        // Google does not offer translation guidance for this disclaimer, so it's English for all languages.
        // @see https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-badge.-what-is-allowed
      }
      <p className="recaptcha-disclaimer">
        This site is protected by reCAPTCHA and the Google{" "}
        <a href="https://policies.google.com/privacy" target="_blank">
          Privacy Policy
        </a>{" "}
        and{" "}
        <a href="https://policies.google.com/terms" target="_blank">
          Terms of Service
        </a>{" "}
        apply.
      </p>
    </div>
  );
}

export default AcknowledgeRecurringDonationMessage;
